module.exports = __webpack_public_path__ + "img/blue_phone.096617b3.svg";